export default __webpack_public_path__ + "static/media/LogoOkamura.a8f9aa91.webp";